import { createRootReducer } from './store';
import { configureStore } from "@reduxjs/toolkit";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const store = configureStore({ reducer: createRootReducer(), devTools: true });

export default store;